const RESERVED_GAMES_SEGMENTS = [
  'category',
  'providers',
  'live',
  'jogos-do-padrinho',
];

function isGameRoute(path: string) {
  const match = path.match(/^\/games\/([^/]+)\/[^/]+/);

  if (!match || !match[1]) return false;

  return !RESERVED_GAMES_SEGMENTS.includes(match[1]);
}

export default defineNuxtPlugin(() => {
  const router = useRouter();
  const { isMobile } = useLayout();
  const casino = useCasinoStore();
  const { openPreview } = useGameMobilePreview();
  const { isAuthenticated } = storeToRefs(useAuthStore());

  async function openPreviewForSlug(slug: string) {
    try {
      const { getApostatudoApiUrl } = await import(
        '~/utils/apostatudo/get-apostatudo-api-url'
      );

      const res = await fetch(`${getApostatudoApiUrl()}/games?slug=${slug}`, {
        headers: { Accept: 'application/json' },
      });

      const data = await res.json();

      openPreview({
        id: data.id,
        slug: data.slug ?? slug,
        name: data.name,
        image: data.image,
        provider: data.provider,
        provider_id: data.provider_id,
        reference: data.reference,
        casino_game_type_id: data.casino_game_type_id,
        demo: data.demo,
        rtp: data.rtp,
        tags: data.tags ?? [],
        ribbon: data.ribbon ?? null,
      } as any);
    } catch {}
  }

  // Abre o preview quando ?previewGame está na query (redirect server-side ou fallback)
  router.afterEach((to) => {
    if (!to.query.previewGame) return;

    const slug = String(to.query.previewGame);

    // Remove da URL imediatamente
    const { previewGame: _, ...rest } = to.query;

    router.replace({ path: to.path, query: rest });

    openPreviewForSlug(slug);
  });

  // Intercepta navegação interna para rotas de jogo no mobile
  router.beforeEach((to, from) => {
    if (!isGameRoute(to.path)) return true;
    if (!isMobile.value) return true;
    if (casino.isGameModalOpen) return true;
    if (from.matched.length === 0) return true;
    // Bypass: ?direct=true em mobile + logado abre o jogo sem o modal de preview
    if (to.query.direct === 'true' && isAuthenticated.value) return true;

    const parts = to.path.replace(/^\//, '').split('/');
    const slug = `${parts[1]}/${parts[2]}`;

    openPreviewForSlug(slug);

    return false;
  });
});
